import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TreeNode } from '../models/tree-node.model';

@Component({
    selector: 'mh-tree',
    templateUrl: './tree.component.html',
    styles: [],
    standalone: false
})
export class TreeComponent {
  @Input() nodes: TreeNode[] = [];
  @Input() activeNodeId: string | number | null = null;

  constructor(private router: Router) {}

  // Prepara los nodos cuando llegan, añadiendo depth y estado inicial
  ngOnChanges(changes: SimpleChanges): void {
    console.error('changes', changes);
    if (changes['nodes'] && this.nodes) {
      this.initializeNodes(this.nodes);
    }
  }

  initializeNodes(nodes: TreeNode[], depth = 0): void {
    nodes.forEach(node => {
      node.depth = depth;
      node.isExpanded = node.isExpanded ?? false;
      if (node.children) {
        this.initializeNodes(node.children, depth + 1);
      }
    });
  }

  // Aquí replicamos la lógica de tu actionMapping
  handleNodeClick(event: { node: TreeNode, event: MouseEvent }): void {
    const { node } = event;

    // Lógica para expandir/colapsar
    if (node.children && node.children.length > 0) {
      node.isExpanded = !node.isExpanded;
      
      // Lógica para colapsar hermanos (depth 1)
      if (node.depth === 1 && node.isExpanded) {
        this.collapseSiblings(node, this.nodes);
      }
    } else {
      // Lógica para navegar si es una hoja (leaf node)
      if (node.route) {
        this.router.navigate([node.route]);
      }
    }
  }

  private collapseSiblings(clickedNode: TreeNode, allNodes: TreeNode[]): void {
    for (const rootNode of allNodes) {
      if (rootNode.children) {
        const parentOfClicked = rootNode.children.find(child => child.id === clickedNode.id);
        if (parentOfClicked) {
          rootNode.children.forEach(sibling => {
            if (sibling.id !== clickedNode.id) {
              this.collapseAllChildren(sibling);
            }
          });
          return; // Salimos una vez encontramos y procesamos el grupo de hermanos
        }
      }
    }
  }

  public collapseAll(): void {
    this.nodes.forEach(node => this.collapseAllChildren(node));
  }
  
  private collapseAllChildren(node: TreeNode): void {
    node.isExpanded = false;
    if (node.children) {
      node.children.forEach(child => this.collapseAllChildren(child));
    }
  }
}
